import {
	downloadPaymentClaim,
	downloadPaymentGroup,
} from 'feature/payments/paymentsSlice';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { AppDispatch } from 'store/store';
import { Button, Stack } from 'styles';
import { PATHNAMES } from 'utils/constants';
import { useTranslation } from 'utils/translations';

type IType = 'claim' | 'group' | 'eop';

const DownloadButton = ({ type }: { type: IType }) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const dispatch = useDispatch<AppDispatch>();
	const location = useLocation();
	const pathnames = location.pathname.split('/');
	const claimUUID = pathnames[pathnames.length - 1];
	const param = useParams();

	const handleClick = () => {
		if (type === 'claim') {
			dispatch(
				downloadPaymentClaim({
					paymentRunId: param.id?.split('|')[0] as string,
					claimUUID,
				}),
			);
		} else {
			const formattedType =
				pathnames[pathnames.length - 1] === PATHNAMES.GROUP_INVOICE_ASSESSMENT
					? 'GROUP_INVOICE'
					: 'EOP';
			dispatch(
				downloadPaymentGroup({
					paymentRunId: param.id?.split('|')[0] as string,
					paymentRunDate: param.id?.split('|')[1] as string,
					type: formattedType,
				}),
			);
		}
	};

	return (
		<Stack>
			<Button
				type="button"
				variant="contained"
				fullWidth={false}
				onClick={handleClick}
			>
				{tClientLabels('claim.button.download')}
			</Button>
		</Stack>
	);
};

export default DownloadButton;
